import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/MaxcomGames/page.tsx");
